import type { PropsElement } from '../props';
import type { ToolFn, ToolSpec } from '../types';
import { countBy, inStorey, ofType, storeyKey } from './select';

export const countSpec: ToolSpec = {
  name: 'count_elements',
  description:
    'Count elements by IFC type (prefix match, e.g. IfcWall matches IfcWallStandardCase; German or English words like "Decke" or "door" work too), optionally within one storey and grouped by storey.',
  input_schema: {
    type: 'object',
    properties: {
      type: { type: 'string', description: 'IFC type prefix, e.g. IfcDoor, IfcSpace, IfcWall' },
      storey: { type: 'string', description: 'Restrict to a storey (substring of its name)' },
      group_by_storey: { type: 'boolean' },
    },
    required: ['type'],
  },
};

export const count =
  (elements: PropsElement[]): ToolFn =>
  ({ type, storey, group_by_storey }) => {
    const hits = inStorey(ofType(elements, type), storey);
    if (!group_by_storey) return { count: hits.length, ids: hits.map((e) => e.expressID) };
    return {
      count: hits.length,
      per_storey: countBy(hits, storeyKey),
      ids: hits.map((e) => e.expressID),
    };
  };
